import { Skeleton as AntdSkeleton } from 'antd';

// Re-exported, not wrapped: Skeleton's appearance is entirely theme config (`feedbackComponents` in
// constants/antd.constants.ts), and wrapping would drop the statics call sites use.
export const Skeleton = AntdSkeleton;

export default Skeleton;
